// extracted by mini-css-extract-plugin
export default {"page":"DormPage_page__sP31K"};